<template>
  <div class="panel-body">
    <import-data :route="filterable.model" :json_fields="headers" :json_data="cargos"></import-data>
    <div class="row">
      <div class="col-md-12">
        <filterable ref="filter" v-bind="filterable">
          <thead slot="thead">
            <tr>
              <th class="col-md-1">{{$t('words.options')}}</th>
              <th>{{$t('attributes.name')}}</th>
              <th>{{$t('attributes.description')}}</th>
              <th>Ambiente</th>
            </tr>
          </thead>
          <tr slot-scope="{item, dropup}">
            <td class="column-options">
              <div class="btn-group" :class="{'dropup': dropup}">
                <button type="button" class="btn btn-default btn-sm dropdown-toggle"
                  v-bind:title="$t('words.operations')" data-toggle="dropdown" aria-haspopup="true"
                  aria-expanded="false">
                  <i class="fa fa-bars" aria-hidden="true"></i>
                  <span class="caret"></span>
                </button>
                <div class="dropdown-menu">
                    <a class="dropdown-item" @click="detailsObject(item)">
                      <i class="fa fa-eye"></i>
                      {{$t('words.details') }}
                    </a>                  
                    <router-link class="dropdown-item" :to="{ name: `cargoEdit`, params: { id: item.id}}">
                      <i class="fa fa-pencil"></i>
                      {{$t('words.edit')}}
                    </router-link>                
                    <a class="dropdown-item" @click="deleteData(item.id, item.cargo_nome, 'cargo')">
                      <i class="fa fa-trash" aria-hidden="true"></i>
                      {{$t('words.delete')}}
                    </a>                
                </div>
              </div>
            </td>
            <td>{{item.cargo_nome}}</td>
            <td>{{item.cargo_descricao}}</td>
            <td>
              <span v-if="item.cargo_ambiente == 1">
                Comercial
              </span>
              <span v-else>
                Administrativo
              </span>
            </td>
          </tr>
        </filterable>
      </div>
    </div>
    <show-data :description="description" :data="objectDetails" :headers="headers"></show-data>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        filterable: {
          url: '/api/cargos',
          storeAction: 'setCargos',
          storeName: 'cargo.data',
          model: 'cargo',
          showLinkDeleted: true
        },
        objectDetails: {},
        description: 'cargo_descricao',
        headers: {
          'Nome': 'cargo_nome',
          'Descrição': 'cargo_descricao'
        }
      };
    },
    computed: {
      cargos() {
        return this.$store.state.cargo.data;
      }
    },
    watch: {
      $route(data) {
        if (data.name === 'cargos') {
          this.prepareComponent();
        }
      }
    }
  };
</script>